import { Controller } from "@hotwired/stimulus";

export default class CountProgressController extends Controller {
  static targets = ["circle", "counter"];

  connect() {
    if (this.hasCounterTarget) {
      this.segmenter = new Intl.Segmenter(undefined, { granularity: 'grapheme' });
      this.maxLength = Number(this.element.dataset.maxLength || 255);

      const input = this.element.querySelector("input, textarea");
      if (input) {
        this.updateCount({ target: input });
      }
    }
  }

  update(event) {
    const { length, max = 280 } = event.detail;
    const inputLength = Math.min(length, max);
    const dashOffset = 100 - (inputLength / max) * 100;
    if (this.hasCircleTarget) {
      this.circleTarget.style.strokeDashoffset = dashOffset;
    }
  }

  updateCount(event) {
    const input = event.target;
    const segments = [...this.segmenter.segment(input.value)];

    if (segments.length > this.maxLength) {
      const selectionStart = input.selectionStart;
      const overflow = segments.length - this.maxLength;
      let graphemeCount = 0;
      let cutIndex = segments.length - 1;

      for (let i = 0; i < segments.length; i++) {
        graphemeCount += segments[i].segment.length;
        if (graphemeCount >= selectionStart) {
          cutIndex = i;
          break;
        }
      }

      segments.splice(cutIndex - overflow + 1, overflow);
      input.value = segments.map(s => s.segment).join('');
      const newCursorPos = Math.max(0, selectionStart - overflow);
      input.setSelectionRange(newCursorPos, newCursorPos);
    }

    const currentLength = Math.min(segments.length, this.maxLength);

    if (this.hasCounterTarget) {
      this.counterTarget.textContent = currentLength;
    }

    this.dispatch('update', { detail: { length: currentLength, max: this.maxLength } });
  }
}
